
const Line  = class {  
  constructor(opt) {
    this.angle = opt.angle
    this.cos = Math.cos( this.angle )
    this.sin = Math.sin( this.angle )
    this.length = opt.length
    this.lengthMove = opt.lengthMove
    this.baseRadius = opt.radius
    this.radius = this.baseRadius
    this.offset = opt.offset
    this.hue = opt.hue
    this.p1x = null
    this.p1y = null
    this.p2x = null
    this.p2y = null
  }
  step(config){
    this.radius = this.baseRadius + Math.sin( ( Date.now() + this.offset ) * config.speed ) * this.lengthMove
    this.p1x = this.cos * ( this.radius - this.length / 2 )
    this.p1y = this.sin * ( this.radius - this.length / 2 )
    this.p2x = this.cos * ( this.radius + this.length / 2 )
    this.p2y = this.sin * ( this.radius + this.length / 2 )
  }
  draw(ctx){
    ctx.beginPath()
    ctx.moveTo( this.p1x, this.p1y )
    ctx.lineTo( this.p2x, this.p2y )
    ctx.strokeStyle = 'hsla(' + this.hue + ', 70%, 50%, 1)'
    ctx.stroke()
  }
}

export default Line
